import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ArticlePost } from '../../shared/interfaces/index.interface';
import { JwtService } from '../index.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrganService {
  readonly BASE_URL = environment.BASE_API_URL;
  public singleOrgan:any = new BehaviorSubject({})

  constructor(
    private http:HttpClient,
    private jwtService:JwtService,
  ) { }
  createOrgan(data:any){
    // this.jwtService.recreacteNewTokenPerRequest();
    return this.http.post(this.BASE_URL+`organ/`,data)
  }
  getUserOrgans(username:string){
    return this.http.get(this.BASE_URL+`organ/o/me/`)
  }
  getSingleOrgan(username:string){
    return this.http.get(this.BASE_URL+`organ/${username}/`)
  }
  canCreateOrgan(){
    return this.http.get(this.BASE_URL+`organ/can_create/`)
  }
  getAllOrgan(page:number=1){
    return this.http.get(this.BASE_URL+`organ/?page=${page}`)
  }
  editOrgan(username:string,data:any){
    return this.http.patch(this.BASE_URL+`organ/${username}/`,data)
  }
}
